import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { TextField, Button, Grid, Checkbox, FormControlLabel, Typography, Modal, TableFooter, TablePagination, InputLabel, FormControl, CircularProgress, FormLabel, FormGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Autocomplete, Select, MenuItem } from '@mui/material';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useSucursal } from '../contexts/SucursalContext';
import GestionClientes from '../Clientes/GestionClientes'; // Importa tu componente GestionClientes
import { useUser } from '../contexts/UserContext';
import ResultadoModal from '../components/ResultadoModal';
import { debounce } from 'lodash'; // Puedes usar lodash para crear la función debounce
import { useMemo, useCallback } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import GestionFactura from './GestionFactura'; // Importa tu componente GestionFactura
import CondicionesUtilidadesModal from './CondicionesUtilidadesModal'; // Ajusta la ruta
import VisibilityIcon from '@mui/icons-material/Visibility';
import ComentariosEntregaModal from './ComentariosEntregaModal';
import ModalPermisoEspecial from '../Seguridad/ModalPermisoEspeciales';
import { useAccesos } from '../contexts/AccesosContext';

const swalWithHighZIndex = Swal.mixin({
    zIndex: 9999
});

function GestionOrdenTrabajo({ ordenTrabajo, onClose, modo, cliente }) {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const { cajaAbiertaDatos, actualizarCajaAbierta, cajaAbierta } = useSucursal();
    const { sucursalSeleccionada } = useSucursal();
    const [clientes, setClientes] = useState([]);
    const [clienteSeleccionado, setClienteSeleccionado] = useState(false);
    const [sucursales, setSucursales] = useState([]);
    const [origenes, setOrigenes] = useState([]);
    const [mediosPago, setMediosPago] = useState([]);
    const [Medicos, setMedicos] = useState([]);
    const [sucursalEntrega, setSucursalEntrega] = useState(sucursalSeleccionada.idSucursal);
    const [IsEditing, setIsEditing] = useState(false);
    const [identidad, setIdentidad] = useState('');
    const [edad, setEdad] = useState('');
    const [sexo, setSexo] = useState('');
    const [direccion, setDireccion] = useState('');
    const [fechaCotizacion, setFechaCotizacion] = useState('');
    const [fechaRecepcion, setFechaRecepcion] = useState('');
    const [fechaEntrega, setFechaEntrega] = useState('');
    const [validez, setValidez] = useState(1);
    const [medidaT, setMedidaT] = useState('');
    const [telefono, setTelefono] = useState('');
    const [correoElectronico, setCorreoElectronico] = useState('');
    const { user } = useUser();
    const [perfil, setPerfil] = useState('');
    const [medicoSeleccionado, setMedicoSeleccionado] = useState('');
    const [origen, setOrigen] = useState('');
    const [medioPago, setMedioPago] = useState('');
    const [tipoPago, setTipoPago] = useState('');
    const [tiempo, setTiempo] = useState('');
    const [tipoTiempoSeleccionado, setTipoTiempoSeleccionado] = useState([]);
    const [observaciones, setObservaciones] = useState('');

    const [whatsapp, setWhatsapp] = useState(false);
    const [app, setApp] = useState(false);
    const [correo, setCorreo] = useState(false);
    const [impresos, setImpresos] = useState(false);

    const [productos, setProductos] = useState([]);
    const [analisisPrecios, setAnalisisPrecios] = useState([]);

    const [tiposPagos, setTiposPagos] = useState([]);
    const [tiposCotizacion, setTiposCotizacion] = useState([]);
    const [unidadesMedida, setUnidadMedida] = useState([]);
    const [areas, setAreas] = useState([]);
    const [prioridadDescuento, setPrioridadDescuento] = useState([]);
    // Cambiado de descuentoAplicado a descuentosAplicados
    const [descuentosAplicados, setDescuentosAplicados] = useState([]);
    const [medidasTiempo, setMedidasTiempo] = useState([]);
    const [polizas, setPolizas] = useState([]);
    const [polizasOrigen, setpolizasOrigen] = useState([]);
    const [sexos, setSexos] = useState([]);
    const [presentacion, setPresentacion] = useState('');
    const [lote, setLote] = useState('');
    const [lotes, setLotes] = useState([]);
    const [area, setArea] = useState('');
    const [disponible, setDisponible] = useState('');
    const [cantidad, setCantidad] = useState(1);
    const [descuento, setDescuento] = useState('');
    const [descuentoGeneral, setDescuentoGeneral] = useState('');
    const [descuentoTotalP, setDescuentoTotalP] = useState('');
    const [descuentoTotal, setDescuentoTotal] = useState('');
    const [totalPagar, setTotalPagar] = useState('');
    const [valorVenta, setValorVenta] = useState('');
    const [cantidadTotal, setCantidadTotal] = useState('');

    const [elegible, setElegible] = useState(false);
    const [comentarios, setComentarios] = useState('');

    const [productosAgregados, setProductosAgregados] = useState([]);

    const [productoSeleccionado, setProductoSeleccionado] = useState(null);

    const [searchQuery, setSearchQuery] = useState(''); // Query actual para la búsqueda
    const [inputValue, setInputValue] = useState(''); // Texto que se muestra en el input
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [totalClientes, setTotalClientes] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [tablePage, setTablePage] = useState(0); // Estado para la página actual de la tabla
    const [rowsPerPage, setRowsPerPage] = useState(5); // Estado para el número de filas por página
    const [openModalCliente, setOpenModalCliente] = useState(false); // Controla la apertura del modal

    const [isAseguradora, setIsAseguradora] = useState(false);
    const [descuentoGlobal, setDescuentoGlobal] = useState(0);
    const [analisisPerfilActual, setAnalisisPerfilActual] = useState([]);

    // Variables para la sección Datos del Paciente Asegurado
    const [poliza, setPoliza] = useState('');
    const [idPoliza, setIdPoliza] = useState('');
    const [empresa, setEmpresa] = useState('');
    const [nTransaccion, setNTransaccion] = useState('');
    const [minimo, setMinimo] = useState('');
    const [maximo, setMaximo] = useState('');
    const [nVerificacion, setNVerificacion] = useState('');
    const [copago, setCopago] = useState('');
    const [autorizado, setAutorizado] = useState(false);
    const [deducible, setDeducible] = useState('');
    const [descuentoAsegurado, setDescuentoAsegurado] = useState('');
    const [valorElegible, setValorElegible] = useState('');
    const [noElegibles, setNoElegibles] = useState('');
    const [aseguradora, setAseguradora] = useState('');
    const [valorCopago, setValorCopago] = useState('');
    const [totalAsegurado, setTotalAsegurado] = useState('');
    const [showModal, setShowModal] = useState(false);

    const [apiResult, setApiResult] = useState({ message: '', status: '' });

    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
    const [showGestionFactura, setShowGestionFactura] = useState(false);
    const [datosFactura, setDatosFactura] = useState(null); // Datos a pasar a GestionFactura

    // Estados para el modal
    const [openModalCondiciones, setOpenModalCondiciones] = useState(false);
    const [selectedAnalisis, setSelectedAnalisis] = useState(null);

    const [openComentariosEntregaModal, setOpenComentariosEntregaModal] = useState(false);
    const [comentariosEntrega, setComentariosEntrega] = useState([]);
    const [analisisOriginal, setAnalisisOriginal] = useState([]);
    const [openExistenciaModal, setOpenExistenciaModal] = useState(false);
    const [existenciasPorArea, setExistenciasPorArea] = useState([]);
    const [modalPermisoAbierto, setModalPermisoAbierto] = useState(false);
    const handleVerCondiciones = (analisis) => {
        console.log(analisis);
        setSelectedAnalisis(analisis);
        setOpenModalCondiciones(true);
    };


    useEffect(() => {
        // Si ambos valores están definidos, calcular la fechaEntrega
        if (tiempo && tipoTiempoSeleccionado) {
            const baseDate = new Date(); // Fecha base: ahora (puedes usar otra, por ejemplo, fechaCotizacion)
            const num = parseInt(tiempo, 10);
            if (!isNaN(num)) {
                const newDate = new Date(baseDate); // Clonamos la fecha base
                switch (tipoTiempoSeleccionado) {
                    case 'hora':
                        newDate.setHours(newDate.getHours() + num);
                        break;
                    case 'dia':
                        newDate.setDate(newDate.getDate() + num);
                        break;
                    case 'semana':
                        newDate.setDate(newDate.getDate() + num * 7);
                        break;
                    case 'mes':
                        newDate.setMonth(newDate.getMonth() + num);
                        break;
                    default:
                        break;
                }
                // Formateamos la fecha para un control "datetime-local" (YYYY-MM-DDTHH:MM)
                const pad = (n) => n.toString().padStart(2, '0');
                const yyyy = newDate.getFullYear();
                const mm = pad(newDate.getMonth() + 1);
                const dd = pad(newDate.getDate());
                const hh = pad(newDate.getHours());
                const min = pad(newDate.getMinutes());
                const formatted = `${yyyy}-${mm}-${dd}T${hh}:${min}`;
                setFechaEntrega(formatted);
            }
        }
    }, [tiempo, tipoTiempoSeleccionado]);

    // Crear una función debounced para 
    const debouncedFetchClientes = useMemo(
        () =>
            debounce((searchText) => {
                fetchClientes(searchText);
            }, 500),
        []
    );

    const handlePermisoConfirmado = (autorizado) => {
        if (autorizado) {
            // Ejecutar la acción protegida
        }
    };

    const obtenerExistenciaProducto = async (idProducto, idAlmacen, idSucursal) => {
        try {
            // const response = await fetch(`${server}/IvProductosExistenciasXAlmacene/${idProducto}/${idAlmacen}/${idSucursal}`);
            const response = await fetch(`${server}/IvProductosExistenciasXAlmacene/${idProducto}/${idAlmacen}/${idSucursal}`);
            const data = await response.json();
            console.log('Existencia del producto:', data);
            return data;
        } catch (error) {
            console.error('Error al obtener existencias por área:', error);
            return 0;
        }
    };

    const handleVerExistencias = async () => {
        console.log('Aqui la existencia');
        if (!productoSeleccionado) return;

        try {
            const response = await fetch(`${server}/IvProductosExistenciasXAlmacene/${productoSeleccionado.id}`);
            const data = await response.json();
            console.log(data.$values);
            setExistenciasPorArea(data.$values || []);
            setOpenExistenciaModal(true);
        } catch (error) {
            console.error('Error al obtener la existencia del producto:', error);
        }
    };


    const handleAnalisisKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAgregarServicio();
        }
    };

    const handlePerfilKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAgregarAnalisisPerfil();
        }
    };
    // Manejar el cambio en el input del Autocomplete
    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);
        debouncedFetchClientes(newInputValue);
    };


    // useEffect(() => {
    //     console.log("ordenTrabajo en useEffect:", ordenTrabajo);
    //     if (ordenTrabajo) {
    //         fetchComentarios(ordenTrabajo.idOrdenMedica);
    //         // ... otras acciones
    //     }
    // }, [ordenTrabajo]);
    const fetchComentarios = async (idOrden) => {
        try {
            const response = await fetch(`${server}/MgOrdenesMedicasComentariosEntregas/porOrden/${idOrden}`);
            const data = await response.json();
            
            // Formatear comentarios para el modal
            const comentariosFormateados = data.$values ? data.$values.map(c => ({
                id: c.id,
                comentarios: c.comentarios,
                fechaIngreso: c.fechaIngreso,
                ingresadoPor: c.ingresadoPor,
                isNew: false
            })) : [];
            
            setComentariosEntrega(comentariosFormateados);
            console.log('Comentarios cargados:', comentariosFormateados);
        } catch (error) {
            console.error('Error al cargar los comentarios de entrega:', error);
            setComentariosEntrega([]);
        }
    };

    // ✅ Función para guardar comentarios desde el modal
    const handleGuardarComentariosEntrega = async (comentariosValidos, comentariosEliminados = []) => {
        if (!ordenTrabajo?.idOrdenMedica) {
            console.warn('No hay orden seleccionada para guardar comentarios');
            return;
        }

        try {
            console.log('💾 Guardando comentarios desde GestionOrdenTrabajoHospital');
            console.log('Comentarios válidos:', comentariosValidos);
            console.log('Comentarios a eliminar:', comentariosEliminados);

            // 1. Eliminar comentarios marcados
            const username = user ? `${user.codigoUsuario}/` : 'ADMIN/';
            for (const idComentario of comentariosEliminados) {
                try {
                    const deleteResponse = await fetch(
                        `${server}/MgOrdenesMedicasComentariosEntregas/${idComentario}/${username}`,
                        { method: 'DELETE' }
                    );
                    if (!deleteResponse.ok) {
                        console.error('Error al eliminar comentario:', idComentario, deleteResponse.status);
                    } else {
                        console.log('✅ Comentario eliminado exitosamente:', idComentario);
                    }
                } catch (error) {
                    console.error('Error al eliminar comentario:', error);
                }
            }

            // 2. Guardar solo comentarios nuevos (isNew === true)
            const comentariosNuevos = comentariosValidos.filter(c => c.isNew);
            console.log('📝 Comentarios nuevos a guardar:', comentariosNuevos);

            for (const comentario of comentariosNuevos) {
                const payloadComentario = {
                    idOrdenMedica: ordenTrabajo.idOrdenMedica,
                    comentarios: comentario.comentarios,
                    ingresadoPor: user ? user.codigoUsuario : 'ADMIN'
                };

                const responseComentario = await fetch(`${server}/MgOrdenesMedicasComentariosEntregas`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payloadComentario)
                });

                if (!responseComentario.ok) {
                    console.error('Error al guardar comentario:', responseComentario.statusText);
                }
            }

            // 3. Recargar comentarios actualizados desde la API
            await fetchComentarios(ordenTrabajo.idOrdenMedica);

            // Opcional: mostrar notificación de éxito
            if (comentariosNuevos.length > 0 || comentariosEliminados.length > 0) {
                Swal.fire({
                    icon: 'success',
                    title: 'Comentarios actualizados',
                    text: `${comentariosNuevos.length} guardado(s), ${comentariosEliminados.length} eliminado(s)`,
                    showConfirmButton: false,
                    timer: 1500
                });
            }

            setOpenComentariosEntregaModal(false);
        } catch (error) {
            console.error('Error al guardar comentarios:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudieron guardar los comentarios'
            });
        }
    };

    const obtenerDescuentoPorOrigen = async (idOrigen) => {
        try {
            const response = await fetch(`${server}/mg_origen_empresa_descuento_por_uso/byidorigen/${idOrigen}`);
            const data = await response.json();
            // Si la API devuelve la información en data.$values o directamente un array
            const records = data.$values ? data.$values : (Array.isArray(data) ? data : []);
            // Filtra el registro que tiene id_Clasificacion_Producto === 2
            const registro = records.find(item => item.id_Clasificacion_Producto === 2);
            if (registro) {
                return {
                    descuento: registro.descuento || 0,
                    descuento_remitido: registro.descuento_remitido || 0
                };
            } else {
                return { descuento: 0, descuento_remitido: 0 };
            }
        } catch (error) {
            console.error('Error al obtener descuento por origen:', error);
            return { descuento: 0, descuento_remitido: 0 };
        }
    };


    const obtenerDescuentoPorTarjeta = async (idMedioPago) => {

        try {
            const fechaActual = new Date();
            const añoActual = fechaActual.getFullYear();

            const fechaDesde = `${añoActual}-01-01`;
            const fechaHasta = `${añoActual}-12-31`;

            const response = await fetch(`${server}/PrPromociones/byidtipopromocion/3`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    search: '',
                    desde: fechaDesde,
                    hasta: fechaHasta
                })
            });

            const data = await response.json();
            const promociones = data.$values || [];
            console.log(promociones);

            // Filtrar promociones activas según la fecha de cotización
            const promocionesActivas = promociones.filter(promo => {
                const fechaDesdePromo = new Date(promo.fechaDesde);
                const fechaHastaPromo = new Date(promo.fechaHasta);
                const fechaCot = new Date(fechaCotizacion);

                return fechaCot >= fechaDesdePromo && fechaCot <= fechaHastaPromo;
            });

            let maxDescuento = 0;
            let idPromocionAplicada = null;
            for (const promo of promocionesActivas) {
                const responseDetalles = await fetch(`${server}/PrDetallesDeDescuentosXTarjetasBancarias/byIdPromocion/${promo.id}`);
                const dataDetalles = await responseDetalles.json();
                const detalles = dataDetalles.$values || [];

                // Buscar si el perfil seleccionado está en los detalles
                const detalleMedioP = detalles.find(detalle => detalle.idTarjeta === idMedioPago);

                if (detalleMedioP && detalleMedioP.porcentaje > maxDescuento) {
                    maxDescuento = detalleMedioP.porcentaje;
                    idPromocionAplicada = promo.id; // Guarda el id de la promoción
                }
            }

            return { porcentaje: maxDescuento, idPromocion: idPromocionAplicada };
        } catch (error) {
            console.error('Error al obtener el descuento por medio de pago:', error);
            return 0;
        }
    };


    const obtenerDescuentoPorPerfil = async (idPerfil) => {
        try {
            const fechaActual = new Date();
            const añoActual = fechaActual.getFullYear();

            const fechaDesde = `${añoActual}-01-01`;
            const fechaHasta = `${añoActual}-12-31`;

            const response = await fetch(`${server}/PrPromociones/byidtipopromocion/2`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    search: '',
                    desde: fechaDesde,
                    hasta: fechaHasta
                })
            });

            const data = await response.json();
            const promociones = data.$values || [];


            // Filtrar promociones activas según la fecha de cotización
            const promocionesActivas = promociones.filter(promo => {
                const fechaDesdePromo = new Date(promo.fechaDesde);
                const fechaHastaPromo = new Date(promo.fechaHasta);
                const fechaCot = new Date(fechaCotizacion);

                return fechaCot >= fechaDesdePromo && fechaCot <= fechaHastaPromo;
            });

            let maxDescuento = 0;
            let idPromocionAplicada = null;

            for (const promo of promocionesActivas) {
                const responseDetalles = await fetch(`${server}/PrDetallesDeDescuentosXPerfilDeAnalisis/byidpromocion/${promo.id}`);
                const dataDetalles = await responseDetalles.json();
                const detalles = dataDetalles.$values || [];

                // Buscar si el perfil seleccionado está en los detalles
                const detallePerfil = detalles.find(detalle => detalle.idPerfil === idPerfil);

                if (detallePerfil && detallePerfil.porcentaje > maxDescuento) {
                    maxDescuento = detallePerfil.porcentaje;
                    idPromocionAplicada = promo.id; // Guarda el id de la promoción
                }
            }

            return { porcentaje: maxDescuento, idPromocion: idPromocionAplicada };
        } catch (error) {
            console.error('Error al obtener el descuento por perfil:', error);
            return { porcentaje: 0, idPromocion: null };
        }
    };



    const obtenerDescuentoPorAnalisis = async (idTipoAnalisis) => {
        try {
            const fechaActual = new Date();
            const añoActual = fechaActual.getFullYear();

            const fechaDesde = `${añoActual}-01-01`;
            const fechaHasta = `${añoActual}-12-31`;

            const response = await fetch(`${server}/PrPromociones/byidtipopromocion/1`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    search: '',
                    desde: fechaDesde,
                    hasta: fechaHasta
                })
            });

            const data = await response.json();
            const promociones = data.$values || [];

            // Filtrar promociones activas según la fecha de cotización
            const promocionesActivas = promociones.filter(promo => {
                const fechaDesdePromo = new Date(promo.fechaDesde);
                const fechaHastaPromo = new Date(promo.fechaHasta);
                const fechaCot = new Date(fechaCotizacion);

                return fechaCot >= fechaDesdePromo && fechaCot <= fechaHastaPromo;
            });

            console.log('AQUI' + promocionesActivas);

            let maxDescuento = 0;
            let idPromocionAplicada = null; // Agregar esta línea
            for (const promo of promocionesActivas) {
                const responseDetalles = await fetch(`${server}/PrPromocionesDetallesDeDescuentoes/byidpromocion/${promo.id}`);
                const dataDetalles = await responseDetalles.json();
                const detalles = dataDetalles.$values || [];

                // Buscar si el análisis está en los detalles
                const detalleAnalisis = detalles.find(detalle => detalle.idTipoAnalisis === idTipoAnalisis);

                console.log(detalleAnalisis);
                if (detalleAnalisis && detalleAnalisis.porcentaje > maxDescuento) {
                    maxDescuento = detalleAnalisis.porcentaje;
                    idPromocionAplicada = promo.id; // Guarda el id de la promoción
                }

                if (detalleAnalisis.remitido) {
                    maxDescuento = detalleAnalisis.porcentajeRemitido;
                    idPromocionAplicada = promo.id; // Guarda el id de la promoción
                }
            }

            console.log('AQUI' + maxDescuento, idPromocionAplicada);

            return { porcentaje: maxDescuento, idPromocion: idPromocionAplicada };
        } catch (error) {
            console.error('Error al obtener el descuento por análisis:', error);
            return { porcentaje: 0, idPromocion: 0 }; // Cambiar de return 0; a este objeto
        }
    };


    const calcularDescuento = async () => {
        let descuentos = [];

        // Descuento por origen
        if (origen) {
            const descuentoOrigen = await obtenerDescuentoPorOrigen(origen.idOrigen);
            const prioridad = prioridadDescuento.find(p => p.id === 2);
            // Se toma el valor de descuento_remitido si el análisis seleccionado tiene remitido === true,
            // de lo contrario se usa el descuento normal.
            const porcentajeOrigen = productoSeleccionado && productoSeleccionado.remitido
                ? descuentoOrigen.descuento_remitido
                : descuentoOrigen.descuento;
            descuentos.push({
                tipo: 'Origen',
                porcentaje: porcentajeOrigen,
                orden: prioridad ? prioridad.orden : Infinity
            });
        }


        // Descuento por médico
        if (medicoSeleccionado && medicoSeleccionado.porcentajeDescuento) {
            const prioridad = prioridadDescuento.find(p => p.id === 3);
            descuentos.push({
                tipo: 'Médico',
                porcentaje: medicoSeleccionado.porcentajeDescuento,
                orden: prioridad ? prioridad.orden : Infinity
            });
        }

        // Descuento por tercera edad
        if (clienteSeleccionado && clienteSeleccionado.fechaNacimiento && esTerceraEdad(clienteSeleccionado.fechaNacimiento)) {
            const prioridad = prioridadDescuento.find(p => p.id === 1);
            descuentos.push({
                tipo: 'Tercera Edad',
                porcentaje: 30, // 30% de descuento
                orden: prioridad ? prioridad.orden : Infinity
            });
        }

        // Descuento por medio de pago
        if (medioPago) {
            const resultadoDescuento = await obtenerDescuentoPorTarjeta(medioPago.id);
            const porcentajeDescuento = resultadoDescuento?.porcentaje || 0;
            const prioridad = prioridadDescuento.find(p => p.id === 7);
            descuentos.push({
                tipo: 'MedioPago',
                porcentaje: porcentajeDescuento,
                orden: prioridad ? prioridad.orden : Infinity
            });
        }

        // Ordenar descuentos por prioridad (menor número, mayor prioridad)
        descuentos.sort((a, b) => a.orden - b.orden);

        let descuentoAplicar = descuentos[0] || null;

        if (descuentoAplicar) {
            // Aplicar descuento global
            setDescuentoGlobal(descuentoAplicar.porcentaje);
            setDescuento(descuentoAplicar.porcentaje);
        } else {
            // No hay descuentos globales, establecer en 0
            setDescuentoGlobal(0);
            setDescuento(0);
        }

        // Recalcular los descuentos en los análisis agregados
        const nuevosAnalisisAgregados = await recalcularDescuentosAnalisisAgregados(productosAgregados);
        setProductosAgregados(nuevosAnalisisAgregados);
        calcularTotales(nuevosAnalisisAgregados);
    };



    const esTerceraEdad = (fechaNacimiento) => {
        console.log(fechaNacimiento);
        const hoy = new Date();
        const fechaNac = new Date(fechaNacimiento);
        let edad = hoy.getFullYear() - fechaNac.getFullYear();
        const m = hoy.getMonth() - fechaNac.getMonth();
        console.log(m);
        if (m < 0 || (m === 0 && hoy.getDate() < fechaNac.getDate())) {
            edad--;
        }
        console.log(edad);
        return edad >= 60;
    };



    const recalcularDescuentosAnalisisAgregados = async (analisisArray, descuentosAplicadosParam = descuentosAplicados) => {
        const nuevosAnalisisAgregados = await Promise.all(
            analisisArray.map(async (analisis) => {
                let porcentajeDescuento = 0;

                if (descuentoGlobal > 0) {
                    // Si hay descuento global, este tiene prioridad sobre cualquier otro descuento
                    porcentajeDescuento = descuentoGlobal;
                } else {
                    // Verificar si el análisis pertenece a un perfil con descuento
                    const descuentosAplicadosActuales = descuentosAplicadosParam || descuentosAplicados;
                    const descuentoPerfil = descuentosAplicadosActuales.find(
                        (descuento) =>
                            descuento.tipo === 'Perfil' && descuento.idPerfil === analisis.idPerfil
                    );

                    if (descuentoPerfil) {
                        // Aplicar el descuento del perfil
                        porcentajeDescuento = analisis.remitido ? descuentoPerfil.descuento_remitido : descuentoPerfil.porcentaje;
                    } else {
                        // Aplicar descuento individual por análisis si existe
                        const resultadoDescuento = await obtenerDescuentoPorAnalisis(analisis.idTipoAnalisis);
                        porcentajeDescuento = resultadoDescuento?.porcentaje || 0;
                    }
                }

                const descuentoMonto = (analisis.precio * porcentajeDescuento) / 100;
                const total = (analisis.precio - descuentoMonto) * analisis.cantidad;

                return {
                    ...analisis,
                    descuento: descuentoMonto.toFixed(2),
                    total: total.toFixed(2),
                };
            })
        );

        return nuevosAnalisisAgregados;
    };

    const aplicarDescuentoAnalisisAgregados = (porcentajeDescuento) => {
        const nuevosAnalisisAgregados = productosAgregados.map((analisis) => {
            const descuento = (analisis.precio * porcentajeDescuento) / 100;
            const total = (analisis.precio - descuento) * analisis.cantidad;

            return {
                ...analisis,
                descuento: descuento.toFixed(2),
                total: total.toFixed(2)
            };
        });

        setProductosAgregados(nuevosAnalisisAgregados);
        calcularTotales(nuevosAnalisisAgregados);
    };


    useEffect(() => {
        calcularDescuento();
    }, [medicoSeleccionado, origen, clienteSeleccionado, perfil, fechaCotizacion, medioPago]);


    const fetchClientes = async (search = '') => {
        try {
            setIsLoading(true);

            const response = await fetch(`${server}/MgClientes/buscador/${search}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });

            const data = await response.json();

            if (data && data.clientes && Array.isArray(data.clientes.$values)) {
                const clientesData = data.clientes.$values;

                setClientes(clientesData);
                setTotalClientes(data.total);
            } else {
                setClientes([]);
            }
        } catch (error) {
            console.error('Error al cargar los clientes:', error);
        } finally {
            setIsLoading(false);
        }
    };


    const handleOrigenChange = async (e, newValue) => {
        setOrigen(newValue);
        if (newValue && newValue.aseguradora && clienteSeleccionado && clienteSeleccionado.idPoliza) {
            setIsAseguradora(true);
            console.log(clienteSeleccionado);
            // Validar que idPoliza no sea cero
            if (clienteSeleccionado && clienteSeleccionado.idPoliza !== 0) {
                console.log('entro al if');
                try {
                    const response = await fetch(`${server}/MgPolizasDeSeguroes/byidorigen/${newValue.idOrigen}`);
                    const data = await response.json();
                    setpolizasOrigen(data.$values);
                    // const codigoPoliza = polizas.find((p) => p.idPoliza === clienteSeleccionado.idPoliza);
                    // Busca el idPoliza en el resultado
                    const poliza = data.$values.find((p) => p.id === clienteSeleccionado.idPoliza);

                    if (poliza) {
                        setPoliza(poliza.codigo);
                        setMinimo(poliza.valorMinimo);
                        setMaximo(poliza.valorMaximo);
                        setCopago(poliza.porcentajeCopago);
                        setIdPoliza(clienteSeleccionado.idPoliza);
                    }

                    // Recalcular elegible y no elegible con los análisis actuales
                    recalcularElegiblesNoElegibles(productosAgregados);
                } catch (error) {
                    console.error("Error al obtener los detalles de la póliza:", error);
                }
            }
        } else {
            setIsAseguradora(false);
        }
    };

    // función para verificar si la póliza del cliente se encuentra entre las pólizas del origen
    const isPolizaValidForOrigen = (clientePoliza, origenPolizas) => {
        console.log(origenPolizas);
        return clientePoliza && origenPolizas.some(poliza => poliza.id === clientePoliza);
    };


    // Función para calcular los valores elegibles y no elegibles
    const recalcularElegiblesNoElegibles = (analisis) => {


        // Si el cliente no tiene póliza o no coincide con el origen, no se calculan los valores
        if (!isPolizaValidForOrigen(clienteSeleccionado.idPoliza, polizas)) {
            setValorElegible(0);
            setNoElegibles(0);
            setValorCopago(0);
            setTotalAsegurado(0);
            return;
        }


        const totalElegible = analisis
            .filter((a) => a.elegible)
            .reduce((acc, curr) => acc + parseFloat(curr.total), 0);

        const totalNoElegible = analisis
            .filter((a) => !a.elegible)
            .reduce((acc, curr) => acc + parseFloat(curr.total), 0);


        // Calcular porcentaje de aseguradora y copago basado en el porcentaje de copago
        const porcentajeAseguradora = 100 - copago;
        const valorAseguradora = (porcentajeAseguradora / 100) * totalElegible;
        const valorCopago = (copago / 100) * totalElegible;



        // Setear los valores calculados
        setValorElegible(totalElegible.toFixed(2));
        setNoElegibles(totalNoElegible.toFixed(2));
        setAseguradora(valorAseguradora.toFixed(2));
        setValorCopago(valorCopago.toFixed(2));

        // Calcular y setear el total asegurado
        const totalAsegurado = totalNoElegible + valorCopago;
        setTotalAsegurado(totalAsegurado.toFixed(2));
    };

    // Llama a la función `recalcularElegiblesNoElegibles` cada vez que se agrega un análisis
    useEffect(() => {
        if (poliza) {
            recalcularElegiblesNoElegibles(productosAgregados);
        }
    }, [productosAgregados]);

    const handleElegibleChange = (index) => {
        setProductosAgregados((prevAnalisis) => {
            const updatedAnalisis = prevAnalisis.map((analisis, i) => {
                if (i === index) {
                    return { ...analisis, elegible: !analisis.elegible };
                }
                return analisis;
            });

            if (isPolizaValidForOrigen(clienteSeleccionado.idPoliza, polizas)) {
                recalcularElegiblesNoElegibles(updatedAnalisis);
            }
            return updatedAnalisis;
        });

    };

    // Función para obtener los detalles de la cotización
    const obtenerDetallesOrdenTrabajo = async (idOrdenTrabajo) => {
        try {
            const response = await fetch(`${server}/MgOrdenesMedicasDetalles/idOrdenTrabajo/${idOrdenTrabajo}`);
            const data = await response.json();
            if (data && data.$values) {
                const detallesAnalisis = data.$values.map((detalle) => ({
                    idDetalle: detalle.idDetalle,
                    idOrdenMedica: detalle.idOrdenMedica,
                    idModulo: detalle.idModulo,
                    nombreModulo: detalle.nombreModulo,
                    idPerfil: 0,
                    perfil: '',
                    idTipoAnalisis: detalle.idTipoAnalisis,
                    analisis: detalle.descripcionTipoAnalisis,
                    cantidad: 1,
                    idTipoPrecio: detalle.idTipoPrecio,
                    precio: detalle.valorVenta,
                    descuento: detalle.valorDescuento,
                    total: (parseFloat(detalle.valorVenta) - parseFloat(detalle.valorDescuento)) * 1,
                    elegible: detalle.polizaElegible || false,
                    // En este ejemplo usamos idDetalle para identificar cada registro
                }));
                setProductosAgregados(detallesAnalisis);
                // Guardamos también el arreglo original para la comparación
                setAnalisisOriginal(detallesAnalisis);
                calcularTotales(detallesAnalisis);
            }
        } catch (error) {
            console.error("Error al obtener los detalles de la cotización:", error);
        }
    };

    useEffect(() => {
        if (ordenTrabajo) {
            console.log('Entraron aqui', ordenTrabajo, modo);
            if (modo === 'dividir') {
                setFechaCotizacion(ordenTrabajo.fechaCotizacion || '');
                setValidez(ordenTrabajo.duracion || 1);
                setMedidaT(ordenTrabajo.idTipoDuracion || '');
                setTipoPago(ordenTrabajo.idTipoPago || '');
                setMedicoSeleccionado(ordenTrabajo.idMedico || null);
                setOrigen(ordenTrabajo.idOrigen || null);
                setMedioPago(ordenTrabajo.medioPago || null);
                setObservaciones(ordenTrabajo.observaciones || '');
                setWhatsapp(ordenTrabajo.enviarXWhatsapp || '');
                setCorreo(ordenTrabajo.enviarXCorreo || '');
                setApp(ordenTrabajo.enviarXApp || '');
                setImpresos(ordenTrabajo.imprimir || '');
                setMedicoSeleccionado(ordenTrabajo.idMedico || null);
                setOrigen(ordenTrabajo.idOrigen || null);
                fetchComentarios(ordenTrabajo.idOrdenMedica);
                // setAnalisisAgregados(detalles || []);
                setIsEditing(false); // Indicador de modo edición
                // Busca el cliente en la lista de clientes


            } else if (modo === 'modificar') {
                console.log('Entro en Modificar', ordenTrabajo);
                setFechaCotizacion(ordenTrabajo.fechaCotizacion || '');
                setValidez(ordenTrabajo.duracion || 1);
                setMedidaT(ordenTrabajo.idTipoDuracion || '');
                setTipoPago(ordenTrabajo.idTipoPago ? ordenTrabajo.idTipoPago : 1 || '');
                setMedicoSeleccionado(ordenTrabajo.idMedico || null);
                setOrigen(ordenTrabajo.idOrigen || null);
                setMedioPago(ordenTrabajo.medioPago || null);
                setObservaciones(ordenTrabajo.observaciones || '');
                setWhatsapp(ordenTrabajo.enviarXWhatsapp || '');
                setCorreo(ordenTrabajo.enviarXCorreo || '');
                setApp(ordenTrabajo.enviarXApp || '');
                setImpresos(ordenTrabajo.imprimir || '');
                setMedicoSeleccionado(ordenTrabajo.idMedico || null);
                setOrigen(ordenTrabajo.idOrigen || null);
                fetchComentarios(ordenTrabajo.idOrdenMedica);
                // setAnalisisAgregados(detalles || []);
                setIsEditing(true); // Indicador de modo edición

            }

            const cliente = clientes.find(c => c.idCliente === ordenTrabajo.idCliente);
            if (cliente) {
                setClienteSeleccionado(cliente);
                setInputValue(cliente.nombreCompleto);
                // Llama a handleClienteSeleccionado para llenar otros campos
                handleClienteSeleccionado(null, cliente);
            } else {
                // Si el cliente no está en la lista, lo obtienes desde la API
                fetch(`${server}/MgClientes/GetByIdCliente/${ordenTrabajo.idCliente}`)
                    .then(response => response.json())
                    .then(data => {
                        console.log(data);
                        setClienteSeleccionado(data);
                        setInputValue(data.nombreCompleto);
                        handleClienteSeleccionado(null, data);
                    })
                    .catch(error => {
                        console.error('Error al obtener el cliente:', error);
                    });
            }


            console.log(ordenTrabajo);
            obtenerDetallesOrdenTrabajo(ordenTrabajo.idOrdenMedica);

        } else if (cliente) {
            // Nuevo caso: se ha proporcionado un cliente sin una orden de trabajo
            setClienteSeleccionado(cliente);
            setInputValue(cliente.nombreCompleto);
            // Inicializar otros estados con la información del cliente
            setIdentidad(cliente.numeroIdentidad);
            const fechaNacimiento = new Date(cliente.fechaNacimiento);
            const hoy = new Date();
            let edadAnios = hoy.getFullYear() - fechaNacimiento.getFullYear();
            let edadMeses = hoy.getMonth() - fechaNacimiento.getMonth();

            if (edadMeses < 0) {
                edadAnios--;
                edadMeses += 12;
            }

            const edadCalculada = `${edadAnios} años y ${edadMeses} meses`;
            setEdad(edadCalculada);
            setSexo(cliente.idSexo);
            setDireccion(cliente.direccionCompleta);
            setTelefono(cliente.telefono);
            setCorreoElectronico(cliente.correoElectronico);

            // Inicializar otros estados según necesites
            // Por ejemplo, fechas, sucursal, etc.
            setFechaCotizacion(new Date().toISOString().split('T')[0]); // Fecha actual en formato YYYY-MM-DD
            setValidez(1);
            setMedidaT('');
            setTipoPago('');
            setWhatsapp(false);
            setApp(false);
            setCorreo(false);
            setImpresos(false);
            setMedicoSeleccionado(null);
            setOrigen(null);
            setMedioPago(null);
            setObservaciones('');
            setPerfil(null);
            setProductoSeleccionado(null);
            setProductosAgregados([]);
            setCantidad(1);
            setDisponible(0);
            setDescuento(0);
            setTotalPagar(0);
            setDescuentoTotal(0);
            setDescuentoTotalP(0);
            setCantidadTotal(0);
            setDescuentoGlobal(0);
            // ... otros estados necesarios
        } else {

            // Si no hay cotización, inicializamos los estados a sus valores por defecto
            setClienteSeleccionado(null);
            setFechaCotizacion('');
            setValidez(1);
            setMedidaT('');
            setTipoPago('');
            setMedicoSeleccionado(null);
            setOrigen(null);
            setMedioPago(null);
            setObservaciones('');
            setWhatsapp(false);
            setApp(false);
            setCorreo(false);
            setImpresos(false);
            setProductosAgregados([]);
            setIsEditing(false); // Modo creación
        }
    }, [ordenTrabajo, modo, cliente]);



    useEffect(() => {
        // Establecer fechas iniciales al cargar el componente
        const now = new Date();

        // Para fechaCotizacion (solo fecha)
        const currentYear = now.getFullYear();
        const currentMonth = String(now.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 (enero) a 11 (diciembre)
        const currentDay = String(now.getDate()).padStart(2, '0');

        const fechaActual = `${currentYear}-${currentMonth}-${currentDay}`; // Formato YYYY-MM-DD

        // Para fechaRecepcion y fechaEntrega (fecha y hora)
        const currentHours = String(now.getHours()).padStart(2, '0');
        const currentMinutes = String(now.getMinutes()).padStart(2, '0');

        const fechaHoraActual = `${fechaActual}T${currentHours}:${currentMinutes}`; // Formato YYYY-MM-DDTHH:MM

        setFechaCotizacion(fechaActual); // Solo fecha
        setFechaRecepcion(fechaHoraActual); // Fecha y hora
        setFechaEntrega(fechaHoraActual);   // Fecha y hora
    }, []);



    const handleSearch = async () => {
        setSearchQuery(inputValue); // Actualiza searchQuery con el valor actual del input
        setPage(0);
        setHasMore(true);
        await fetchClientes(inputValue); // Ejecuta la búsqueda con el texto escrito
    };

    // Manejar la pulsación de la tecla "Enter"
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // Evita que el formulario se recargue
            handleSearch(); // Ejecuta la búsqueda al presionar Enter
        }
    };



    // Fetch de datos desde las APIs para llenar los autocomplete y selects
    useEffect(() => {
        fetchClientes(searchQuery);


        const fetchSexo = async () => {
            try {
                const response = await fetch(`${server}/MgSexoes`);
                const data = await response.json();
                setSexos(data.$values);
            } catch (error) {
                console.error('Error al cargar las sucursales:', error);
            }
        };

        const fetchSucursales = async () => {
            try {
                const response = await fetch(`${server}/MgSucursales`);
                const data = await response.json();
                setSucursales(data.$values);
            } catch (error) {
                console.error('Error al cargar las sucursales:', error);
            }
        };

        const fetchMedicos = async () => {
            try {
                const response = await fetch(`${server}/MgMedicoes`);
                const data = await response.json();
                setMedicos(data.$values);
            } catch (error) {
                console.error('Error al cargar los médicos:', error);
            }
        };

        const fetchOrigen = async () => {
            try {
                const response = await fetch(`${server}/MgOrigenes`);
                const data = await response.json();
                setOrigenes(data.$values);
            } catch (error) {
                console.error('Error al cargar los orígenes:', error);
            }
        };

        const fetchMedioPago = async () => {
            try {
                const response = await fetch(`${server}/MgTarjetasBancarias`);
                const data = await response.json();
                setMediosPago(data.$values);
            } catch (error) {
                console.error('Error al cargar los medios de pago:', error);
            }
        };


        const fetchProductos = async () => {
            try {
                const response = await fetch(`${server}/IvProductoes`);
                const data = await response.json();
                setProductos(data.$values);
                // console.log(data.$values);
            } catch (error) {
                console.error('Error al cargar los tipos de analisis:', error);
            }
        };

        // const fetchAnalisisPrecios = async () => {
        //     try {
        //         const response = await fetch(`${server}/MgAnalisisGeneralTiposDeAnalisis/Analisispreciossucursallista`);
        //         const data = await response.json();
        //         setAnalisisPrecios(data.$values);
        //         console.log(data.$values);
        //     } catch (error) {
        //         console.error('Error al cargar los tipos de analisis:', error);
        //     }
        // };


        const fetchTiposCotizacion = async () => {
            try {
                const response = await fetch(`${server}/CtzCotizacionesTipoes`);
                const data = await response.json();
                setTiposCotizacion(data.$values);
            } catch (error) {
                console.error('Error al cargar las cotizaciones:', error);
            }
        };


        const fetchTiposPagos = async () => {
            try {
                const response = await fetch(`${server}/CtzTiposDePagoes`);
                const data = await response.json();
                setTiposPagos(data.$values);
                console.log(data.$values);
            } catch (error) {
                console.error('Error al cargar las cotizaciones:', error);
            }
        };

        const fetchTiposPrecio = async () => {
            try {
                const response = await fetch(`${server}/IvUnidades`);
                const data = await response.json();
                setUnidadMedida(data.$values);
            } catch (error) {
                console.error('Error al cargar las cotizaciones:', error);
            }
        };

        const fetchAreas = async () => {
            try {
                const response = await fetch(`${server}/MgAreas/areasbyempresa/2`);
                const data = await response.json();
                setAreas(data.$values);
            } catch (error) {
                console.error('Error al cargar las areas:', error);
            }
        };

        const fetchPrioridadesDescuento = async () => {
            try {
                const response = await fetch(`${server}/conf_prioridad_descuento`);
                const data = await response.json();
                setPrioridadDescuento(data.$values);
            } catch (error) {
                console.error('Error al cargar las cotizaciones:', error);
            }
        };

        const fetchMedidasTipos = async () => {
            try {
                const response = await fetch(`${server}/CtzTipoDuracions`);
                const data = await response.json();
                setMedidasTiempo(data.$values);
            } catch (error) {
                console.error('Error al cargar las cotizaciones:', error);
            }
        };

        const fetchPolizas = async () => {
            try {
                const response = await fetch(`${server}/MgPolizasDeSeguroes`);
                const data = await response.json();
                setPolizas(data.$values);
            } catch (error) {
                console.error('Error al cargar las cotizaciones:', error);
            }
        };

        // Llamar las funciones para obtener los datos
        fetchClientes();
        fetchSucursales();
        fetchMedicos();
        fetchOrigen();
        fetchMedioPago();
        fetchProductos();
        fetchSexo();
        fetchTiposCotizacion();
        fetchTiposPagos();
        fetchMedidasTipos();
        fetchTiposPrecio();
        // fetchAnalisisPrecios();
        fetchPrioridadesDescuento();
        fetchPolizas();
        fetchAreas();
    }, []);


    const fetchLotesProducto = async (idProducto) => {
        try {
            const response = await fetch(`${server}/IvProductosLotes/ByProducto/${idProducto}`);
            const data = await response.json();
            setLotes(data.$values || []);
        } catch (error) {
            console.error('Error al cargar las sucursales:', error);
        }
    };

    // Funciones para manejar la paginación de la tabla
    const handleChangeTablePage = (event, newPage) => {
        setTablePage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setTablePage(0);
    };


    const handleOpenModalCliente = () => {
        if (!clienteSeleccionado) {
            alert('Por favor, selecciona un cliente para editar.');
            return;
        }
        setOpenModalCliente(true);
    };

    const handleCloseModalCliente = () => {
        setOpenModalCliente(false);
    };


    const handleClienteActualizado = async () => {
        // Volver a obtener la información del cliente actualizado
        console.log(clienteSeleccionado.idCliente);
        if (clienteSeleccionado) {
            try {
                const response = await fetch(`${server}/MgClientes/GetByIdCliente/${clienteSeleccionado.idCliente}`);
                const data = await response.json();
                setClienteSeleccionado(data);
            } catch (error) {
                console.error('Error al actualizar la información del cliente:', error);
            }
        }
        // Cerrar el modal
        handleCloseModalCliente();
    };


    const handleEditarCliente = (event) => {

    };

    // Función para calcular totales
    const calcularTotales = (analisisArray) => {
        let valorVentaTotal = 0;
        let descuentoTotalSuma = 0;
        let totalPagarSuma = 0;
        let totalanalsis = 0;

        analisisArray.forEach((analisis) => {
            valorVentaTotal += parseFloat(analisis.precio) * parseInt(analisis.cantidad);
            descuentoTotalSuma += parseFloat(analisis.descuento) * parseInt(analisis.cantidad);
            totalPagarSuma += parseFloat(analisis.total);
            totalanalsis += parseInt(analisis.cantidad);
        });

        const descuentoTotalPorcentaje =
            valorVentaTotal > 0 ? (descuentoTotalSuma / valorVentaTotal) * 100 : 0;

        setValorVenta(valorVentaTotal.toFixed(2));
        setDescuentoTotal(descuentoTotalSuma.toFixed(2));
        setDescuentoTotalP(descuentoTotalPorcentaje.toFixed(2));
        setTotalPagar(totalPagarSuma.toFixed(2));
        setCantidadTotal(totalanalsis);
    };

    const handleAgregarServicio = async () => {
        if (!productoSeleccionado) {
            alert('Por favor, selecciona un análisis.');
            return;
        }
        console.log(productoSeleccionado);
        if (!clienteSeleccionado) {
            alert('Por favor, selecciona un cliente antes de agregar un análisis.');
            return;
        }

        // Verificar si ya se agregó este análisis (evitar duplicados)
        if (productosAgregados.some(a => a.id === productoSeleccionado.id)) {
            alert("El Servicio ya ha sido agregado. No se pueden duplicar.");
            return;
        }

        const valorNumerico = parseFloat(productoSeleccionado.precioVenta ?? 0);
        const porcentajeDescuento = parseFloat(descuento ?? 0);
        const cantidadNumerica = parseInt(cantidad) || 1;


        let impuesto = 0;
        let porcentajeImpuesto = 0;

        if (productoSeleccionado.idGravado === 1) {
            impuesto = valorNumerico * 0.15;
            porcentajeImpuesto = 15;
        } else if (productoSeleccionado.idGravado === 2) {
            impuesto = valorNumerico * 0.18;
            porcentajeImpuesto = 18;
        }

        const descuentoMonto = (valorNumerico * porcentajeDescuento) / 100;
        const total = (valorNumerico - descuentoMonto + impuesto) * cantidadNumerica;



        const nuevoServicio = {
            id: 0,
            idArea: area,
            idGravado: productoSeleccionado.idGravado,
            idProducto: productoSeleccionado.id,
            descripcionProducto: productoSeleccionado.descripcion,
            idUnidad: productoSeleccionado.idUnidadMinima,
            precioCosto: parseFloat(productoSeleccionado.precioCosto) || 0,
            cantidad: cantidadNumerica,
            precioVenta: valorNumerico,
            idUnidadFinal: presentacion,
            precioCostoFinal: parseFloat(productoSeleccionado.precioCosto) || 0,
            cantidadFinal: cantidadNumerica,
            precioVentaFinal: valorNumerico,
            precioVentaOriginal: valorNumerico,
            impuesto: impuesto.toFixed(2),
            porcentajeImpuesto,
            idTipoIsv: productoSeleccionado.idTipoIsv,
            polizaElegible: false,
            comentarios: comentarios,
            descuento: parseFloat(descuentoMonto),
            total: parseFloat(total)

        };

        console.log(nuevoServicio);
        setProductosAgregados((prevAnalisis) => {
            const updatedAnalisis = [...prevAnalisis, nuevoServicio];
            calcularTotales(updatedAnalisis);
            


            // Llama al cálculo si es válido según la póliza
            if (isPolizaValidForOrigen(clienteSeleccionado.idPoliza, polizas)) {
                recalcularElegiblesNoElegibles([...productosAgregados, nuevoServicio]);
            }
            return updatedAnalisis;
        });

        // Limpieza de campos después de agregar
        setProductoSeleccionado(null);
        setLotes([]);
        setPresentacion(null);
        setDisponible(0);
        setCantidad(1);
        setDescuento(0);
    };




    const handleAgregarAnalisisPerfil = async () => {
        if (!perfil) {
            alert('Por favor, selecciona un perfil.');
            return;
        }

        try {
            const response = await fetch(`${server}/MgAnalisisGeneralPerfilesAnalisis/AnalisisbyPerfilbySucursal/${perfil.idPerfil}/${sucursalSeleccionada.idSucursal}`);
            const data = await response.json();

            if (data && data.$values && Array.isArray(data.$values)) {
                const idsAnalisisPerfil = data.$values.map(a => a.idTipoAnalisis);

                // Obtener el descuento por perfil solo si descuentoGlobal es 0
                let porcentajeDescuentoPerfil = 0;
                let idPromocionPerfil = null;
                if (descuentoGlobal === 0) {
                    const resultadoDescuento = await obtenerDescuentoPorPerfil(perfil.idPerfil);
                    porcentajeDescuentoPerfil = resultadoDescuento?.porcentaje || 0;
                    idPromocionPerfil = resultadoDescuento?.idPromocion || null;
                }

                const nuevosAnalisis = data.$values.map((analisisItem) => {
                    let porcentajeDescuento = porcentajeDescuentoPerfil;

                    // Si hay descuentoGlobal, este tiene prioridad
                    if (descuentoGlobal > 0) {
                        porcentajeDescuento = descuentoGlobal;
                    }

                    const precio = parseFloat(analisisItem.precio);
                    const descuentoMonto = (precio * porcentajeDescuento) / 100;
                    const total = (precio - descuentoMonto) * 1; // cantidad = 1

                    return {
                        idPerfil: perfil.idPerfil,
                        perfil: perfil.descripcionPerfil,
                        idTipoAnalisis: analisisItem.idTipoAnalisis,
                        analisis: analisisItem.descripcionTipoAnalisis,
                        cantidad: 1,
                        idTipoPrecio: analisisItem.idTipoPrecio,
                        precio: precio,
                        descripcionTipoPrecio: analisisItem.descripcionTipoPrecio,
                        idModulo: analisisItem.idModulo,
                        descuento: descuentoMonto.toFixed(2),
                        total: total.toFixed(2),
                        elegible: false,
                        comentarios: '',
                        idPromocion: idPromocionPerfil
                    };
                });

                // Solo agregar el descuento del perfil si descuentoGlobal es 0 y el porcentaje de descuento del perfil es mayor que 0
                if (descuentoGlobal === 0 && porcentajeDescuentoPerfil > 0) {
                    setDescuentosAplicados((prevDescuentos) => [
                        ...prevDescuentos,
                        {
                            tipo: 'Perfil',
                            porcentaje: porcentajeDescuentoPerfil,
                            idPerfil: perfil.idPerfil,
                            idsAnalisisPerfil: idsAnalisisPerfil,
                            idPromocion: idPromocionPerfil
                        },
                    ]);
                }

                setProductosAgregados((prevAnalisis) => {
                    const updatedAnalisis = [...prevAnalisis, ...nuevosAnalisis];
                    calcularTotales(updatedAnalisis);
                    return updatedAnalisis;
                });

                if (isPolizaValidForOrigen(clienteSeleccionado.idPoliza, polizas)) {
                    recalcularElegiblesNoElegibles([...productosAgregados, ...nuevosAnalisis]);
                }

                setPerfil(null);
            } else {
                alert('No se encontraron análisis para el perfil seleccionado.');
            }
        } catch (error) {
            console.error('Error al cargar los análisis del perfil:', error);
            // alert('Hubo un error al cargar los análisis del perfil.');
        }
    };



    const handleEliminarAnalisis = async (index) => {
        // Eliminar el análisis seleccionado
        const updatedAnalisis = productosAgregados.filter((_, i) => i !== index);

        // Actualizar los descuentos
        const nuevosDescuentosAplicados = descuentosAplicados.filter((descuento) => {
            if (descuento.tipo === 'Perfil') {
                const idsAnalisisAgregados = updatedAnalisis.map((a) => a.idTipoAnalisis);
                const perfilCompleto = descuento.idsAnalisisPerfil.every((idAnalisis) =>
                    idsAnalisisAgregados.includes(idAnalisis)
                );

                if (!perfilCompleto) {
                    // Si el perfil ya no está completo, eliminar el descuento de ese perfil
                    // y actualizar los análisis que pertenecían al perfil
                    updatedAnalisis.forEach((analisis) => {
                        if (descuento.idsAnalisisPerfil.includes(analisis.idTipoAnalisis)) {
                            analisis.idPerfil = 0;
                            analisis.perfil = '';
                        }
                    });
                }

                return perfilCompleto; // Mantener el descuento si el perfil está completo
            }
            return true; // Mantener otros descuentos
        });

        // Recalcular los descuentos de los análisis restantes
        const nuevosAnalisisAgregados = await recalcularDescuentosAnalisisAgregados(
            updatedAnalisis,
            nuevosDescuentosAplicados
        );

        // Actualizar el estado con los nuevos valores
        setProductosAgregados(nuevosAnalisisAgregados);
        setDescuentosAplicados(nuevosDescuentosAplicados);
        calcularTotales(nuevosAnalisisAgregados);
    };




    const limpiarFormulario = () => {
        setClienteSeleccionado(null);
        setInputValue('');
        setIdentidad('');
        setEdad('');
        setSexo('');
        setDireccion('');
        setTelefono('');
        setCorreoElectronico('');
        setFechaCotizacion('');
        setValidez(1);
        setMedidaT('');
        setTipoPago('');
        setWhatsapp(false);
        setApp(false);
        setCorreo(false);
        setImpresos(false);
        setMedicoSeleccionado(null);
        setOrigen(null);
        setMedioPago(null);
        setObservaciones('');
        setPerfil('');
        setProductoSeleccionado(null);
        setProductosAgregados([]);
        setCantidad(1);
        setDisponible(0);
        setDescuento('');
        setTotalPagar('');
        setDescuentoTotal('');
        setDescuentoTotalP('');
        setCantidadTotal('');
        setDescuentoGlobal(0);
        setPoliza('');
        setEmpresa('');
        setNTransaccion('');
        setMinimo(0);
        setMaximo(0);
        setNVerificacion('');
        setCopago('');
        setAutorizado(false);
        setDeducible(0);
        setValorElegible(0);
        setNoElegibles(0);
        setAseguradora(0);
        setValorCopago(0);
        setTotalAsegurado(0);
    };



    const handleGuardarOrdenTrabajo = async () => {
        try {

            if (!cajaAbierta) {
                swalWithHighZIndex.fire({
                    title: 'Error',
                    text: 'No hay caja abierta. Por favor, inicie la caja antes de crear la orden.',
                    icon: 'error',
                    zIndex: 2000 // Asegúrate de que este valor sea mayor al z-index de tu modal
                });
                return;
            }
            // console.log(ordenTrabajo.idOrdenMedica);


            // Datos originales que vienen de la orden (ordenTrabajo)
            const datosOriginales = {
                idCliente: ordenTrabajo?.idCliente,
                fechaCotizacion: ordenTrabajo?.fechaOrdenMedica, // corresponde a la fecha de cotización original
                idTipoPago: ordenTrabajo?.idTipoPago,
                valorVenta: ordenTrabajo?.valorVenta,
                valorDescuento: ordenTrabajo?.valorDescuento,
                valorRecargo: ordenTrabajo?.valorRecargo,
                telefono: ordenTrabajo?.telefono,
                celular: ordenTrabajo?.celular,
                idSucursal: ordenTrabajo?.idSucursal,
                idMedico: ordenTrabajo?.idMedico,
                idOrigen: ordenTrabajo?.idOrigen,
                idMedioPago: ordenTrabajo?.idMedioPago,
                enviarXWhatsapp: ordenTrabajo?.enviarXWhatsapp,
                enviarXCorreo: ordenTrabajo?.enviarXCorreo,
                enviarXApp: ordenTrabajo?.enviarXApp,
                imprimir: ordenTrabajo?.imprimir,
                porcetajeCopago: ordenTrabajo?.porcetajeCopago,
                idPoliza: ordenTrabajo?.idPoliza,
                polizaValorMinimo: ordenTrabajo?.polizaValorMinimo,
                polizaValorMaximo: ordenTrabajo?.polizaValorMaximo,
                polizaPrevalidado: ordenTrabajo?.polizaPrevalidado,
                idSucursalEntrega: ordenTrabajo?.idSucursalEntrega,
                polizaNumeroTransaccion: ordenTrabajo?.polizaNumeroTransaccion,
                polizaNumeroVericacion: ordenTrabajo?.polizaNumeroVericacion,
                polizaDeduccible: ordenTrabajo?.polizaDeduccible,
                polizaElegible: ordenTrabajo?.polizaElegible,
                idTipo: ordenTrabajo?.idTipo,
                idTipoCliente: ordenTrabajo?.idTipoCliente,
                fechaRecepcion: ordenTrabajo?.fechaRecepcion,
                fechaEntrega: ordenTrabajo?.fechaEntrega,
                observaciones: ordenTrabajo?.observaciones,
                // Se asume que la orden original incluye también el array de análisis (detalles)
                analisis: ordenTrabajo?.analisis || []
            };

            // Datos actuales que se han modificado en el formulario
            const datosActuales = {
                idCliente: clienteSeleccionado?.idCliente,
                fechaCotizacion: fechaCotizacion, // el nuevo valor de fecha de cotización
                idTipoPago: tipoPago,
                valorVenta: totalPagar, // valor total (venta)
                valorDescuento: descuentoTotal,
                valorRecargo: deducible || 0,
                telefono: clienteSeleccionado?.telefono || '',
                celular: clienteSeleccionado?.celular || '',
                idSucursal: sucursalSeleccionada?.idSucursal,
                idMedico: medicoSeleccionado ? medicoSeleccionado.idMedico : 0,
                idOrigen: origen ? origen.idOrigen : 0,
                idMedioPago: medioPago ? medioPago.id : null,
                enviarXWhatsapp: whatsapp,
                enviarXCorreo: correo,
                enviarXApp: app,
                imprimir: impresos,
                porcetajeCopago: copago,
                idPoliza: idPoliza,
                polizaValorMinimo: minimo || 0,
                polizaValorMaximo: maximo || 0,
                polizaPrevalidado: autorizado,
                idSucursalEntrega: sucursalEntrega,
                polizaNumeroTransaccion: nTransaccion,
                polizaNumeroVericacion: nVerificacion,
                polizaDeduccible: deducible,
                polizaElegible: parseFloat(valorElegible),
                idTipo: 1, // Suponemos que este valor es constante
                idTipoCliente: origen ? (origen.empresa === 1 ? 2 : 1) : 1,
                fechaRecepcion: fechaRecepcion,
                fechaEntrega: fechaEntrega,
                observaciones: observaciones,
                // Los análisis que se han agregado/modificado
                analisis: productosAgregados
            };

            // Verificar que haya un cliente seleccionado y que analisisAgregados no esté vacío
            if (!clienteSeleccionado) {
                alert('Por favor, selecciona un cliente.');
                return;
            }


            if (productosAgregados.length === 0) {
                alert('Por favor, agrega al menos un análisis a la cotización.');
                return;
            }

            const datosModificados = JSON.stringify(datosOriginales) !== JSON.stringify(datosActuales);

            if (!datosModificados) {
                swalWithHighZIndex.fire({
                    icon: 'info',
                    title: 'Sin cambios',
                    text: 'No hay cambios para guardar.',
                });
                return;
            }

            // Obtener el correlativo
            const responseCant = await fetch(`${server}/MgOrdenesMedicas/cantidad`);
            const data = await responseCant.json();
            const correlativoActual = parseInt(data.toString().slice(4)); // Eliminar los primeros 4 dígitos
            const nuevoCorrelativo = correlativoActual + 1;

            // Obtener el año y el mes actuales
            const fechaActual = new Date();
            const year = fechaActual.getFullYear().toString().slice(-2); // Últimos 2 dígitos del año
            const month = (fechaActual.getMonth() + 1).toString().padStart(2, '0'); // Mes con dos dígitos

            // Construir idOrdenMedicaMes
            const idOrdenMedicaMes = `${year}${month}${nuevoCorrelativo}`;

            // Preparar los datos de la cotización
            const OrdenTrabajoData = {
                idOrdenMedica: ordenTrabajo ? ordenTrabajo.idOrdenMedica : 0,
                idOrdenMedicaMes: idOrdenMedicaMes,
                idCliente: clienteSeleccionado.idCliente,
                correo: clienteSeleccionado.correoElectronico ? clienteSeleccionado.correoElectronico : '',
                idBarrioColonia: clienteSeleccionado.idBarrioColonia,
                fechaOrdenMedica: fechaCotizacion,
                duracion: 1,
                idTipoDuracion: 1,
                idTipoPago: tipoPago ? tipoPago.id : 1,
                valorVenta: totalPagar,
                valorDescuento: descuentoTotal,
                valorRecargo: deducible ? deducible : 0,
                telefono: clienteSeleccionado.telefono ? clienteSeleccionado.telefono : "",
                celular: clienteSeleccionado.celular ? clienteSeleccionado.celular : '',
                idSucursal: sucursalSeleccionada.idSucursal,
                idMedico: medicoSeleccionado ? medicoSeleccionado.idMedico : 0,
                idOrigen: origen ? origen.idOrigen : 0,
                idMedioPago: medioPago ? medioPago.id : null,
                // Convierte a booleano: si es "" se evaluará como false
                enviarXWhatsapp: Boolean(whatsapp),
                enviarXCorreo: Boolean(correo),
                enviarXApp: Boolean(app),
                imprimir: Boolean(impresos),
                porcetajeCopago: copago,
                idPoliza: idPoliza,
                polizaValorMinimo: minimo ? minimo : 0,
                polizaValorMaximo: maximo ? maximo : 0,
                polizaPrevalidado: autorizado,
                idSucursalEntrega: sucursalEntrega,
                polizaNumeroTransaccion: nTransaccion,
                polizaNumeroVericacion: nVerificacion,
                polizaDeduccible: deducible,
                polizaElegible: parseFloat(valorElegible),
                idPoliza: 0,
                idTipo: 1,
                idTipoCliente: origen ? (origen.empresa === 1 ? 2 : 1) : 1,
                // En modo modificar, incluir ambos campos
                ...(modo === 'modificar'
                    ? {
                        modificadoPor: user ? user.codigoUsuario : 'ADMIN',
                        ingresadoPor: user ? user.codigoUsuario : 'ADMIN'
                    }
                    : { ingresadoPor: user ? user.codigoUsuario : 'ADMIN' }
                ),
                fechaRecepcion: fechaRecepcion,
                fechaEntrega: fechaEntrega,
                idOrdenParaControl: 0,
                observaciones: observaciones
            };


            console.log(OrdenTrabajoData);

            const method = modo === 'modificar' ? 'PUT' : 'POST';
            if (method === 'POST') {
                delete OrdenTrabajoData.idOrdenMedica;
            }
            console.log(method);
            const url =
                modo === 'modificar'
                    ? `${server}/MgOrdenesMedicas/${ordenTrabajo.idOrdenMedica}`
                    : `${server}/MgOrdenesMedicas`;
            // Realizar la solicitud POST o PUT para guardar la cotización
            console.log(url);
            const response = await fetch(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(OrdenTrabajoData),
            });

            if (!response.ok) {
                throw new Error('Error al guardar la orden de trabajo');
            }

            const responseText = await response.text();
            let result;
            if (responseText) {
                result = JSON.parse(responseText);
            } else {
                result = {};
            }
            console.log(result);
            const idOrdenMedica = result.idOrdenMedica || (ordenTrabajo && ordenTrabajo.idOrdenMedica);

            if (!idOrdenMedica) {
                throw new Error('No se recibió el id de la orden de trabajo');
            }




            // <-- NUEVA FUNCIÓN: Guardar Comentarios de Entrega -->
            if (comentariosEntrega && comentariosEntrega.length > 0) {
                for (const comentario of comentariosEntrega) {
                    const payloadComentario = {
                        idOrdenMedica: idOrdenMedica,
                        comentarios: comentario.comentario,
                        ingresadoPor: user ? user.codigoUsuario : 'ADMIN'
                    };
                    const responseComentario = await fetch(`${server}/MgOrdenesMedicasComentariosEntregas`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(payloadComentario)
                    });
                    if (!responseComentario.ok) {
                        console.error('Error al guardar el comentario de entrega:', responseComentario.statusText);
                    }
                }
            }

            // Ahora, manejar los análisis agregados
            // Si es una actualización, puedes optar por eliminar los detalles existentes y volver a crearlos,
            // o actualizar cada detalle individualmente.

            // Aquí, por simplicidad, eliminaremos los detalles existentes y agregaremos los nuevos.
            const username = '' + user.codigoUsuario + '/';
            if (modo === 'modificar') {
                // Eliminar detalles existentes
                await fetch(`${server}/MgOrdenesMedicasDetalles/Deletebyorden/${idOrdenMedica}/${username}`, {
                    method: 'DELETE',
                });
            }


            if (isPolizaValidForOrigen(clienteSeleccionado.idPoliza, polizasOrigen)) {


                const analisisDataPoliza = {
                    idOrdenMedica: idOrdenMedica,
                    idClasificacionPorUso: 2,
                    PorcentajeCopago: copago,
                    valorMinimo: minimo,
                    valorMaximo: maximo,
                    deducuble: deducible,
                    elegible: valorElegible,
                    noElegible: noElegibles,
                    descuento: descuentoTotal,
                    copago: valorCopago,
                    aseguradora: aseguradora,
                    asegurado: valorCopago,
                    ingresadoPor: user ? user.codigoUsuario : 'ADMIN',
                    fechaIngreso: fechaCotizacion
                    // Agrega otros campos necesarios según tu API
                };

                console.log(analisisDataPoliza);


                const responseDetallePoliza = await fetch(`${server}/MgOrdenesMedicasDetallePolizas`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(analisisDataPoliza)
                });

                if (!responseDetallePoliza.ok) throw new Error('Error al guardar el detalle de póliza');
            }

            console.log(productosAgregados);
            // Agregar los nuevos detalles
            for (const producto of productosAgregados) {
                const analisisData = {
                    id: 0,
                    idOrdenMedica: idOrdenMedica,
                    idArea: producto.idArea,
                    idGravado: producto.idGravado,
                    idProducto: producto.id,
                    idUnidad: producto.idUnidad,
                    idMedico: producto.idMedico,
                    precioCosto: producto.precioCosto,
                    cantidad: producto.cantidad,
                    precioVenta: producto.precioVenta,
                    idUnidadFinal: producto.idUnidadFinal,
                    precioCostoFinal: producto.precioCostoFinal,
                    cantidadFinal: producto.cantidadFinal,
                    precioVentaFinal: producto.precioVentaFinal,
                    promocion: producto.promocion,
                    precioVentaOriginal: producto.precioVentaOriginal,
                    recargo: producto.recargo,
                    descuento: producto.descuento,
                    comision: producto.comision,
                    idPromocion: producto.idPromocion,
                    promocionCodigo: producto.promocionCodigo,
                    porcentajeImpuesto: producto.porcentajeImpuesto,
                    idTipoIsv: producto.idTipoIsv,
                    polizaElegible: producto.polizaElegible,
                    comentarios: producto.comentarios,
                    ingresadoPor: user ? user.codigoUsuario : 'ADMIN'

                };



                console.log('aqui guardo el analisis ', analisisData);
                const analisisResponse = await fetch(`${server}//MgOrdenesDeTrabajoDetalles`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(analisisData),
                });


                if (!analisisResponse.ok) {
                    throw new Error('Error al guardar el producto de la orden de trabajo');
                }

            }

            if (ordenTrabajo) {
                if (modo === 'modificar') {
                    onClose(); // Cerrar el modal después de modificar
                } else if (modo === 'dividir') {
                    swalWithHighZIndex.fire({
                        icon: 'success',
                        title: 'Orden creada exitosamente',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    onClose(); // Cerrar el modal después de crear
                } else {
                    // Mostrar el diálogo de confirmación
                    setOpenConfirmationDialog(true);
                    // Guardar los datos necesarios para la factura
                    setDatosFactura({
                        ordenTrabajo: result.idOrdenMedica, // Asumimos que este es el número de orden de trabajo
                        nombreCliente: clienteSeleccionado.nombreCompleto,
                        identidad: clienteSeleccionado.numeroIdentidad,
                        TotalPagar: poliza ? totalAsegurado : totalPagar,
                        idSucursal: sucursalSeleccionada.idSucursal,
                        idFormaPago: tipoPago,
                        idCliente: clienteSeleccionado.idCliente
                    });
                    limpiarFormulario();
                }
                swalWithHighZIndex.fire({
                    icon: 'success',
                    title: 'Orden actualizada exitosamente',
                    showConfirmButton: false,
                    timer: 1500,
                });
            } else {
                // Mostrar el diálogo de confirmación
                setOpenConfirmationDialog(true);
                // Guardar los datos necesarios para la factura
                setDatosFactura({
                    ordenTrabajo: result.idOrdenMedica, // Asumimos que este es el número de orden de trabajo
                    nombreCliente: clienteSeleccionado.nombreCompleto,
                    identidad: clienteSeleccionado.numeroIdentidad,
                    TotalPagar: poliza ? totalAsegurado : totalPagar,
                    idSucursal: sucursalSeleccionada.idSucursal,
                    idFormaPago: tipoPago,
                    idCliente: clienteSeleccionado.idCliente
                });
                swalWithHighZIndex.fire({
                    icon: 'success',
                    title: 'Orden creada exitosamente',
                    showConfirmButton: false,
                    timer: 1500,
                });
                limpiarFormulario();
            }

        } catch (error) {
            console.error(error);
            alert('Hubo un error al guardar la orden de Trabajo');
        }
    };

    const handleCloseConfirmationDialog = () => {
        setOpenConfirmationDialog(false);
    };

    const handleConfirmDespachar = () => {
        setOpenConfirmationDialog(false);
        setShowGestionFactura(true);
    };



    const handleClienteSeleccionado = (event, newValue) => {
        setClienteSeleccionado(newValue); // Guardar el cliente seleccionado
        // Restablecer el descuento
        console.log(newValue);
        setDescuento(0);
        if (newValue) {
            setIdentidad(newValue.numeroIdentidad); // Asignar valores adicionales
            const fechaNacimiento = new Date(newValue.fechaNacimiento); // Obtener la fecha de nacimiento
            const hoy = new Date(); // Obtener la fecha actual

            // Calcular años y meses
            let edadAnios = hoy.getFullYear() - fechaNacimiento.getFullYear();
            let edadMeses = hoy.getMonth() - fechaNacimiento.getMonth();

            if (edadMeses < 0) {
                edadAnios--; // Restar un año si aún no ha pasado el mes de cumpleaños
                edadMeses += 12; // Ajustar los meses
            }

            const edadCalculada = `${edadAnios} años y ${edadMeses} meses`;

            // Asignar datos de cliente
            setEdad(edadCalculada);
            setSexo(newValue.idSexo);
            setDireccion(newValue.direccionCompleta);
            setTelefono(newValue.telefono);
            setCorreoElectronico(newValue.correoElectronico);

        } else {
            // Si no hay cliente seleccionado, vaciar los campos
            setIdentidad('');
            setEdad('');
            setSexo('');
            setDireccion('');
            setTelefono('');
            setCorreoElectronico('');
        }
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60%',
        maxHeight: '90vh',
        overflowY: 'auto',
        backgroundColor: '#fff',
        padding: '20px',
        boxShadow: 24,
        outline: 'none',
    };

    return (
        <>
            <div className="right_col" role="main">
                <div className="x_title"></div>
                <div className="x_content">
                    {/* <div className="row"> */}
                    {/* <div className="col-md-9 col-sm-5 offset-md-2"> */}
                    <Grid container spacing={2}>
                        {/* Sección de Datos del Cliente */}
                        <Grid item xs={12}>
                            <Typography variant="h6">Datos del Cliente</Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Autocomplete
                                size="small"
                                freeSolo
                                fullWidth
                                options={clientes}
                                value={clienteSeleccionado}
                                getOptionLabel={(option) => option?.nombreCompleto || ''}
                                inputValue={inputValue}
                                isOptionEqualToValue={(option, value) => option?.idCliente === value?.idCliente}
                                onInputChange={handleInputChange}
                                onChange={handleClienteSeleccionado}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Buscar cliente"
                                        variant="outlined"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Button variant="contained" color="primary" onClick={handleOpenModalCliente}>Editar Cliente</Button>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField size="small" label="Identidad" value={identidad || ''} fullWidth inputProps={{ readOnly: true }} />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextField size="small" label="Edad" value={edad || ''} fullWidth inputProps={{ readOnly: true }} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl size="small" fullWidth required>
                                <InputLabel>Sexo</InputLabel>
                                <Select
                                    size="small"
                                    value={sexo || ''} // Asegúrate de que 'sexo' tenga un valor válido
                                    onChange={(e) => setSexo(e.target.value)}
                                    required
                                    inputProps={{ readOnly: true }}
                                >
                                    {sexos.map((sexo) => (
                                        <MenuItem key={sexo.idSexo} value={sexo.idSexo}>
                                            {sexo.descripcionSexo}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={7}>
                            <TextField size="small" label="Dirección" value={direccion || ''} fullWidth inputProps={{ readOnly: true }} />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField size="small" label="Telefono" value={telefono || ''} fullWidth inputProps={{ readOnly: true }} />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField size="small" label="Correo Electronico" value={correoElectronico || ''} fullWidth inputProps={{ readOnly: true }} />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextField
                                size="small"
                                label="Fecha Hora Recepcion"
                                value={fechaRecepcion || ''}
                                fullWidth
                                type="datetime-local"
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => setFechaRecepcion(e.target.value)}
                            />
                        </Grid>

                        {/* Sección de Datos de la Cotización */}
                        <Grid item xs={12}>
                            <Typography variant="h6">Datos de la orden de trabajo</Typography>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Autocomplete
                                size="small"
                                options={mediosPago}
                                value={medioPago}
                                onChange={(e, newValue) => {
                                    setMedioPago(newValue);

                                }}
                                getOptionLabel={(option) => option.descripcion || ''}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id} // Comparación por ID del medio de pago
                                renderInput={(params) => <TextField size="small" {...params} label="Medio de Pago" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Autocomplete
                                size="small"
                                options={Medicos}
                                value={medicoSeleccionado}
                                onChange={(e, newValue) => setMedicoSeleccionado(newValue)}
                                getOptionLabel={(option) => option.nombreMedico || ''}
                                isOptionEqualToValue={(option, value) => option?.idMedico === value?.idMedico} // Comparación por ID del médico
                                renderInput={(params) => <TextField size="small" {...params} label="Nombre del Médico" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Autocomplete
                                size="small"
                                options={origenes}
                                value={origen}
                                onChange={handleOrigenChange} // Llamada a la función `handleOrigenChange` cuando cambia el origen
                                getOptionLabel={(option) => option.descripcion || ''}
                                isOptionEqualToValue={(option, value) => option?.idOrigen === value?.idOrigen} // Comparación por ID del origen
                                renderInput={(params) => <TextField size="small" {...params} label="Origen" variant="outlined" />}
                            />
                        </Grid>
                        {isAseguradora && (
                            <Grid item xs={12} md={3}>

                                <Typography variant="h5" style={{ color: 'red' }}>
                                    Aseguradora
                                </Typography>

                            </Grid>
                        )}
                        <Grid item xs={12} md={2}>
                            <TextField
                                size="small"
                                label="Desc. General %"
                                type="number"
                                value={descuentoGeneral}
                                onChange={(e) => {
                                    const value = parseFloat(e.target.value);
                                    if (value < 0 || value > 100) {
                                        Swal.fire('Valor inválido', 'El descuento debe estar entre 0 y 100%', 'warning');
                                        return;
                                    }
                                    setDescuentoGeneral(value);
                                    setDescuento(value); // También actualiza el campo descuentoo
                                }}
                                disabled={!tienePermiso('Cambio descuento Hospital')}
                                inputProps={{
                                    min: 0,
                                    max: 100,
                                }}
                                fullWidth
                            />
                        </Grid>

                        {/* Sección de Datos del Análisis */}
                        <Grid item xs={12}>
                            <Typography variant="h6">Datos de Servicios</Typography>

                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Autocomplete
                                size="small"
                                options={areas}
                                getOptionLabel={(option) => option.descripcion || ''}
                                value={areas.find(a => a.id === area) || null}
                                onChange={(event, newValue) => {
                                    setArea(newValue ? newValue.id : '');
                                }}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderInput={(params) => (
                                    <TextField {...params} label="Área" variant="outlined" required />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <TextField size="small" label="Codigo de Barra" value={comentarios || ''} fullWidth InputLabelProps={{ shrink: true }} onChange={(e) => setComentarios(e.target.value)} />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Autocomplete
                                size="small"
                                options={productos}
                                getOptionLabel={(option) => option?.descripcion || ''}
                                value={productoSeleccionado}
                                onChange={async (e, newValue) => {
                                    setProductoSeleccionado(newValue);
                                    if (newValue && area && sucursalSeleccionada?.idSucursal) {
                                        await fetchLotesProducto(newValue.id);
                                        const existencia = await obtenerExistenciaProducto(newValue.id, area, sucursalSeleccionada.idSucursal);
                                        setDisponible(existencia.existencia);
                                        setPresentacion(existencia.idUnidadMinima);
                                        setLote(existencia.idLote);
                                    } else {
                                        setDisponible(0);
                                    }
                                }}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                    <TextField size="small" {...params} label="Servicio Brindado" variant="outlined" onKeyDown={handleAnalisisKeyDown} />
                                )}
                            />


                        </Grid>

                        <Grid item xs={12} md={3}>
                            <FormControl size="small" fullWidth required>
                                <InputLabel>Lote</InputLabel>
                                <Select
                                    size="small"
                                    value={lote || ''} // Asegúrate de que 'tipoPrecio' tenga un valor válido
                                    onChange={(e) => setLote(e.target.value)}
                                    required

                                >
                                    {lotes.map((lote) => (
                                        <MenuItem key={lote.id} value={lote.id}>
                                            {lote.codigo}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl size="small" fullWidth required>
                                <InputLabel>Presentacion</InputLabel>
                                <Select
                                    size="small"
                                    value={presentacion || ''} // Asegúrate de que 'tipoPrecio' tenga un valor válido
                                    onChange={(e) => setPresentacion(e.target.value)}
                                    required

                                >
                                    {unidadesMedida.map((unidad) => (
                                        <MenuItem key={unidad.id} value={unidad.id}>
                                            {unidad.descripcion}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextField
                                size="small"
                                label="Disponible"
                                type="number"
                                value={disponible}
                                onChange={(e) => setDisponible(e.target.value)}
                                fullWidth
                                inputProps={{ readOnly: true }}
                                InputProps={{
                                    endAdornment: disponible === 0 && (
                                        <IconButton onClick={handleVerExistencias}>
                                            <VisibilityIcon color="primary" />
                                        </IconButton>
                                    ),
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <TextField size="small" label="cantidad" type="number" value={cantidad} onChange={(e) => setCantidad(e.target.value)} fullWidth />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextField
                                size="small"
                                label="Desc. (%)"
                                type="number"
                                value={descuento}
                                onChange={(e) => setDescuento(e.target.value)}
                                fullWidth
                                inputProps={{ readOnly: true }}
                            />
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={elegible}
                                        onChange={(e) => setElegible(e.target.checked)}
                                    />
                                }
                                label="Elegible"
                            />
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <TextField size="small" label="Comentarios" value={comentarios || ''} fullWidth InputLabelProps={{ shrink: true }} onChange={(e) => setComentarios(e.target.value)} />
                        </Grid>
                        {/* <Grid item xs={12} md={2}>
                            <Button
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => setOpenComentariosEntregaModal(true)}
                            >
                                Comentarios de Entrega
                            </Button>
                        </Grid> */}
                        <Grid item xs={12} md={12}>
                            <Button size="small" variant="contained" color="primary" onClick={handleAgregarServicio} disabled={!tienePermiso('Agregar análisis Hospital')}>Agregar</Button>
                        </Grid>

                        {/* Tabla de análisis agregados */}
                        <Grid item xs={12}>
                            <TableContainer size="small" component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Acciones</TableCell>
                                            <TableCell>Cantidad</TableCell>
                                            <TableCell>Servicio</TableCell>
                                            <TableCell>Precio</TableCell>
                                            <TableCell>Descuento</TableCell>
                                            <TableCell>Impuesto</TableCell>
                                            <TableCell>Total</TableCell>
                                            <TableCell>Eligeble</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {productosAgregados
                                            .slice(tablePage * rowsPerPage, tablePage * rowsPerPage + rowsPerPage)
                                            .map((producto, index) => {
                                                const actualIndex = tablePage * rowsPerPage + index;
                                                return (
                                                    <TableRow key={actualIndex}>
                                                        <TableCell>
                                                            <IconButton onClick={() => handleEliminarAnalisis(actualIndex)} disabled={!tienePermiso('Eliminar análisis Hospital')}>
                                                                <DeleteIcon />
                                                            </IconButton>
                                                            <IconButton onClick={() => handleVerCondiciones(producto)}>
                                                                <VisibilityIcon color="primary" />
                                                            </IconButton>
                                                        </TableCell>
                                                        <TableCell>{producto.cantidad}</TableCell>
                                                        <TableCell>{producto.descripcionProducto}</TableCell>
                                                        <TableCell>{parseFloat(producto.precioVentaFinal).toFixed(2)}</TableCell>
                                                        <TableCell>{producto.descuento !== undefined && !isNaN(producto.descuento) ? parseFloat(producto.descuento).toFixed(2) : "0.00"}</TableCell>
                                                        <TableCell>{producto.impuesto !== undefined && !isNaN(producto.impuesto) ? parseFloat(producto.impuesto).toFixed(2) : "0.00"}</TableCell>
                                                        <TableCell>{producto.total !== undefined && !isNaN(producto.total) ? parseFloat(producto.total).toFixed(2) : "0.00"}</TableCell>

                                                        <TableCell>
                                                            <Checkbox
                                                                checked={producto.elegible}
                                                                onChange={() => handleElegibleChange(actualIndex)}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TableCell align="right">
                                                <strong>Cantidad de Servicios:</strong>
                                            </TableCell>
                                            <TableCell><strong>{cantidadTotal}</strong></TableCell>
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={productosAgregados.length}
                                    rowsPerPage={rowsPerPage}
                                    page={tablePage}
                                    onPageChange={handleChangeTablePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage="Filas por página:"
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                                />
                            </TableContainer>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextField size="small" label="Observaciones" value={observaciones || ''} fullWidth InputLabelProps={{ shrink: true }} onChange={(e) => setObservaciones(e.target.value)} />
                        </Grid>

                        <Grid container item xs={12} justifyContent="flex-end" spacing={2} sx={{ mt: 0.4 }}>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    size="small"
                                    label="Valor Venta"
                                    type="number"
                                    value={valorVenta}
                                    onChange={(e) => setValorVenta(e.target.value)} // Corregido
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    size="small"
                                    label="% Descuento"
                                    type="number"
                                    value={descuentoTotalP}
                                    onChange={(e) => setDescuentoTotalP(e.target.value)} // Corregido
                                    fullWidth
                                    inputProps={{ readOnly: true }} // Opcional: si deseas que sea solo lectura
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField
                                    size="small"
                                    label="Descuento"
                                    type="number"
                                    value={descuentoTotal}
                                    onChange={(e) => setDescuentoTotal(e.target.value)} // Corregido
                                    fullWidth
                                    inputProps={{ readOnly: true }} // Opcional: si deseas que sea solo lectura
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField
                                    size="small"
                                    label="Total a Pagar"
                                    type="number"
                                    value={totalPagar}
                                    onChange={(e) => setTotalPagar(e.target.value)} // Corregido
                                    fullWidth
                                    inputProps={{ readOnly: true }} // Opcional: si deseas que sea solo lectura
                                />
                            </Grid>
                        </Grid>


                        {/* Botón para guardar cotización */}
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" onClick={handleGuardarOrdenTrabajo} disabled={!tienePermiso('Guardar OT Hospital')}>Guardar Orden de Trabajo</Button>
                            <Button variant="outlined" color="secondary" onClick={onClose} style={{ marginLeft: '10px' }}>
                                Cerrar
                            </Button>
                        </Grid>
                    </Grid>
                    <Modal
                        open={openModalCliente}
                        onClose={handleCloseModalCliente}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <div style={modalStyle}>
                            <GestionClientes
                                cliente={clienteSeleccionado}
                                onClienteGuardado={handleClienteActualizado}
                                onClose={handleCloseModalCliente}
                            />
                        </div>
                    </Modal>
                    {/* </div> */}
                    {/* </div> */}
                    <ResultadoModal
                        open={showModal}
                        onClose={() => setShowModal(false)}
                        resultado={apiResult}
                    />
                    {showGestionFactura && (
                        <Modal
                            open={showGestionFactura}
                            onClose={() => setShowGestionFactura(false)}
                            aria-labelledby="modal-title-factura"
                            aria-describedby="modal-description-factura"
                        >
                            <div style={modalStyle}>
                                <GestionFactura
                                    datosFactura={datosFactura}
                                    onClose={() => setShowGestionFactura(false)}
                                />
                            </div>
                        </Modal>
                    )}
                    <Dialog
                        open={openConfirmationDialog}
                        onClose={handleCloseConfirmationDialog}
                    >
                        <DialogTitle>Despachar Factura</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                ¿Desea despachar la factura?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseConfirmationDialog} color="primary">
                                No
                            </Button>
                            <Button onClick={handleConfirmDespachar} color="primary" autoFocus disabled={!tienePermiso('Facturar OT Hospital')}>
                                Sí
                            </Button>
                        </DialogActions>
                    </Dialog>
                    {openModalCondiciones && selectedAnalisis && (
                        <CondicionesUtilidadesModal
                            open={openModalCondiciones}
                            onClose={() => setOpenModalCondiciones(false)}
                            analysisId={selectedAnalisis}
                        />
                    )}
                    {openComentariosEntregaModal && (
                        <ComentariosEntregaModal
                            open={openComentariosEntregaModal}
                            onClose={() => setOpenComentariosEntregaModal(false)}
                            onSave={handleGuardarComentariosEntrega}
                            initialComentarios={comentariosEntrega}
                        />
                    )}
                    <Modal
                        open={openExistenciaModal}
                        onClose={() => setOpenExistenciaModal(false)}
                        aria-labelledby="modal-title-existencias"
                    >
                        <div style={modalStyle}>
                            <Typography variant="h6">Existencias por Área</Typography>
                            {existenciasPorArea.length > 0 ? (
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Área</TableCell>
                                                <TableCell>Existencia</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {existenciasPorArea.map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{item.areaDescripcion}</TableCell>
                                                    <TableCell>{item.existencia}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ) : (
                                <Typography>No hay existencias disponibles.</Typography>
                            )}
                        </div>
                    </Modal>
                    <ModalPermisoEspecial
                        open={modalPermisoAbierto}
                        onClose={() => setModalPermisoAbierto(false)}
                        nombrePermiso="Cambio descuento"
                        onSuccess={handlePermisoConfirmado}
                    />


                </div>
            </div>
        </>
    );
}

export default GestionOrdenTrabajo;
